import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'
import StyleTwoQuestionBankList from './StyleTwoQuestionBankList'

export class StyleTwoQuestionBank extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    itemsData: {},
    defaultIndex: 1,
  }

  componentWillMount() {
    this.setState({ itemsData: this.props.itemsData });
  }
  toggleTabs(id) {
    let { itemsData } = this.state;
    itemsData.list.map(item => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
    this.setState({ defaultIndex: id, itemsData });
  }
  render() {
    let { itemsData, defaultIndex } = this.state;
    let { onMeiQiaCustomer } = this.props;
    return (
      <div className="topic-style-two-question-bank">
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='question_bank_tabs'>
          <div className='question_bank_tab_header flex_row'>
            {itemsData.list && itemsData.list.map(item => <div className={item.active ? 'question_bank_tabs_item flex_row active' : 'question_bank_tabs_item flex_row'} key={item.id} onClick={this.toggleTabs.bind(this, item.id)}>{item.title}</div>)}
          </div>
          <StyleTwoQuestionBankList Data={itemsData.list[defaultIndex - 1].list} onMeiQiaCustomer={onMeiQiaCustomer} />
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoQuestionBank);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoQuestionBank.js